import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSession } from '../../context/SessionContext';

const PrivateRoute = () => {
    const {isAuthenticated} = useSession()

    if (isAuthenticated == null) {
        return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh', flexDirection: 'column' }}>
            <p>Loading ..</p>
        </div>;
    }

    return isAuthenticated ? <Outlet /> : <Navigate to="/" replace />;
};

export default PrivateRoute;
